// extracted by mini-css-extract-plugin
export var chevron = "_1d-d";
export var disabled = "_1d-b";
export var error = "_1d-c";
export var hideBorder = "_1d-1";
export var icon = "_1d-e";
export var input = "_1d-0";
export var large = "_1d-f";
export var open = "_1d-9";
export var placeholder = "_1d-a";
export var regular = "_1d-5";
export var singleRowInput = "_1d-2";
export var singleSelectInput = "_1d-3 _1d-0";
export var small = "_1d-4";
export var spinnerContainer = "_1d-i";
export var tag = "_1d-7";
export var tagsContainer = "_1d-8";
export var tagsInput = "_1d-6 _1d-0";
export var xSmall = "_1d-g";
export var xxSmall = "_1d-h";